/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AdminUserMlpControllerDeleteUserMlp$Params {
  id: string;
}

export function adminUserMlpControllerDeleteUserMlp(http: HttpClient, rootUrl: string, params: AdminUserMlpControllerDeleteUserMlp$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'message'?: string;
'id'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, adminUserMlpControllerDeleteUserMlp.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'message'?: string;
      'id'?: string;
      }>;
    })
  );
}

adminUserMlpControllerDeleteUserMlp.PATH = '/admin/user-mlp/{id}';
